<template>
<v-flex>
  <v-layout>
    <v-flex xs7>
      <v-text-field type="text" :label="`${index +1}) ${label}`" :value="data.name" :rules="nameRules" @change="update({name: $event})" />
    </v-flex>
    <v-flex xs1>
      <v-dialog width="500" v-model="valuesDialog">
        <v-btn fab dark color="cyan" slot="activator">
          <v-icon>check_circle_outline</v-icon>
        </v-btn>
        <v-card>
          <v-card-title class="headline" primary-title>
            {{ label }} - {{ $t('schema.builder.values') }}
          </v-card-title>
          <v-divider />
          <component :is="this.data.type + '-values'" :id="this.data.id" :values="this.data.values" @update="this.setValues"></component>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn round color="primary" @click="valuesDialog = false">
              {{ $t('base.save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
    <v-flex xs1>
      <description :id="data.id" :fieldName="data.name" :description="data.description" @update="updateDescription($event)" @updateImages="updateOptions"></description>
    </v-flex>
    <v-flex xs1>
      <v-dialog width="500" v-model="optionsDialog">
        <v-btn fab dark color="indigo" slot="activator">
          <v-icon>settings</v-icon>
        </v-btn>
        <v-card>
          <v-card-title class="headline" primary-title>
            {{ label }} - {{ $t('schema.builder.options') }}
          </v-card-title>
          <v-divider />
          <component :is="this.data.type + '-options'" :id="this.data.id" :options="this.data.options" @update="this.updateOptions"></component>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="optionsDialog = false">
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
    <v-flex xs1>
      <v-btn fab dark color="warning" @click="destroy">
        <v-icon>delete_forever</v-icon>
      </v-btn>
    </v-flex>
  </v-layout>
</v-flex>
</template>

<script>
import RadioOptions from './options/RadioOptions'
import FormuleOptions from './options/FormuleOptions'
import RadioValues from './values/RadioValues'
import FormuleValues from './values/FormuleValues'
import Description from './Description'
import field from '@/mixins/field'
import CheckboxOptions from './options/CheckboxOptions'
import CheckboxValues from './values/CheckboxValues'

export default {
  components: {
    Description,
    "radio-options": RadioOptions,
    "formule-options": FormuleOptions,
    "radio-values": RadioValues,
    "formule-values": FormuleValues,
    "checkbox-options": CheckboxOptions,
    "checkbox-values": CheckboxValues
  },
  mixins: [field],
  props: ["data", "index"],
  data() {
    return {
      valuesDialog: false,
      optionsDialog: false
    }
  },
  computed: {
    label() {
      switch (this.data.type) {
      case 'radio':
        return this.$t('schema.builder.inputs.radio-field')
      case 'formule':
        return this.$t('schema.builder.inputs.formule-field')
      case 'checkbox':
        return this.$t('schema.builder.inputs.checkbox-field')
      }
    }
  },
  methods: {
    updateOptions(payload) {
      this.$store.commit("updateFieldOptions", payload)
    },
    setValues(payload) {
      this.$store.commit("setFieldValues", payload)
    },
    update(payload) {
      payload['id'] = this.data.id
      this.$store.commit("updateField", payload)
    },
    destroy() {
      this.$store.commit("removeField", this.index)
    },
    updateDescription(description) {
      let payload = {
        id: this.data.id,
        description
      }
      this.$store.commit("updateFieldDescription", payload)
    }
  }
}
</script>
